import React, { useEffect, useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { nightOwl } from 'react-syntax-highlighter/dist/esm/styles/prism';

const CodeEditor = ({ code, language }) => {
	const [editorLanguage, setEditorLanguage] = useState(language);

	useEffect(() => {
		setEditorLanguage(language);
	}, [language]);

	return (
		<SyntaxHighlighter
				language={editorLanguage}
				style={nightOwl}
				wrapLines={true}
				showLineNumbers={true}
		>
			{code}
		</SyntaxHighlighter>
	);
};

export default CodeEditor;
